module.exports = __webpack_public_path__ + "static/media/IMG_0800.2e5ec067.JPG";